<script setup lang="ts">
interface Props {
  color: string
}

withDefaults(defineProps<Props>(), {
  color: '#212121',
})
</script>

<template>
  <svg
    width="630"
    height="643"
    viewBox="0 0 630 643"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M360.475 283.529L538.421 77H496.254L341.743 256.326L218.336 77H76L262.616 348.172L76 564.749H118.17L281.337 375.375L411.664 564.749H554L360.465 283.529H360.475ZM302.717 350.562L283.809 323.559L133.364 108.696H198.135L319.546 282.097L338.454 309.1L496.274 534.495H431.503L302.717 350.572V350.562Z"
      :fill="color"
    />
  </svg>
</template>
